class ServiceTimeUpdSessionModel extends App.Models.BaseModel { }

App.Models.ServiceTimeUpdSession = ServiceTimeUpdSessionModel;
